export default "__VITE_ASSET__XkMA_mFW__"